var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"content"},[_c('div',[_c('i',{staticClass:"el-icon-guide"}),_vm._v(" 404 Not Found")]),_c('div',{staticClass:"text"},[_vm._v("未找到该页面")]),_c('div',{staticClass:"text"},[_vm._v("请尝试访问主页")])])])
}]

export { render, staticRenderFns }